module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_9.89eb6725.jpg";